// extracted by mini-css-extract-plugin
module.exports = {"happenToWorker":"oshaCompliance_happenToWorker__1a2Yt","toggleText":"oshaCompliance_toggleText__2XF3n"};